<template>
  <div v-if="quick_files.files.length==1" class="single-file">
      <div class="title" :style="{'color':quick_files.title.color}">{{quick_files.title.text}}</div>
      <img src="@/assets/icons/fileicon.png"  class="file-icon" />
      <div class="file-name" :style="{'color':quick_files.title.color}">{{$common.realFilename(quick_files.files[0])}}</div>
      <div class="file-size" :style="{'color':quick_files.title.color}">{{$common.fileSize(quick_files.files[0])}}</div>
      <div class="btn-container">
      <Button label="查看文件" rounded  @click="gotoFile(quick_files.files[0])" :style="{'width':'50%'}"/>
      </div>
  </div>
  <div v-if="quick_files.files.length>1">
      <div class="title" :style="{'color':quick_files.title.color}">{{quick_files.title.text}}</div>
      <div class="file-list">
          <div v-for="file in quick_files.files" :key="file.id" class="file-container" @click="gotoFile(file)">
              <div class="file">
                  <img src="@/assets/icons/fileicon.png" class="file-icon">
                  <div>
                      <div class="filename">{{$common.realFilename(file)}}</div>
                      <div class="filesize">{{$common.fileSize(file)}}</div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>

<script>
import Button from 'primevue/button';

export default {
  name: 'QuickFile',
  components: {
    Button
  },
  data(){
    return {

    }
  },
  props: {
    quick_files: null
  },
  methods:{
    gotoFile(file){

      window.location.href=this.$common.HOST+'/resources/'+file.filename;

    }
  },
  created(){
    
    

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.single-file{
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
}
.single-file .file-icon{
    width:100px;
    margin: 0.5rem auto;
}
.single-file .file-name{
    font-size: 1.2rem;
    line-height: 3rem;
}
.single-file .file-size{
    font-size: 0.8rem;
    line-height: 2rem;
    color:#9a9a9a;
}
.single-file .btn-container{
    width:100%;
    text-align: center;
}
.title{
    font-size: 1.8rem;
    font-weight: 800;
    margin-bottom: 2rem;
    text-align: center;
}
.file-list{
    background-color: #fcfcfc;
    border: 1px solid #dee2e6;
    border-radius: 10px !important;
    overflow: hidden;
    margin:2rem 0;
}

.file-list .file-container{
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid #ebebeb;
        margin-top: 10px;
        margin-bottom: 10px;
}

.file-list .file-container .file{
       display: flex;
       align-items: center;

}

.file-list .file-container .file  .file-icon{
      width: 50px;
      margin-right:0.5rem;
}

.file-list .file-container .file .filename{
      font-size: 14px;
      color: #353535;
      line-height: 1.3;
      word-break: break-all;
}
.file-list .file-container .file .filesize{
      font-size: 12px;
      color: #8b8a8a;
      margin-top: 4px!important;
      margin-bottom: 10px!important;
}
.file-list .file-container:last-child{
    border-bottom: 0px solid rgba(0,0,0,1);
}
.white-font{
    color:white !important;
}
</style>